import direction from 'direction';
export var getTextDirection = function (text) { return direction(text); };
//# sourceMappingURL=textUtils.js.map